import {
  JakeArnoldForParachute,
  getStaticProps,
} from '@public/JakeArnoldForParachute'

export { getStaticProps }

export default JakeArnoldForParachute
